import { FormEvent, useEffect } from 'react'

import ChevronRightIcon from '@mui/icons-material/ChevronRight'

import { Controller, useFormContext } from 'react-hook-form'
import { Button, TextField } from 'ui'
import { DadataMultiSelect } from 'widget/DadataSelectInput'
import { LkmProductType } from 'feature/registration/types'
import { DocumentsUploadInput } from '../DocumentsUploadInput'
import { LkmProductTypes } from '../LkmProductTypes'
import styles from './LkmRegistrationStepTwo.module.scss'

type LkmRegistrationStepTwoProps = {
  onBack?: () => void
  onSubmit?: (event: FormEvent<HTMLFormElement>) => void
  isSubmitting?: boolean
  productTypes: LkmProductType[]
  productTypesError: boolean
  isUpdateForm?: boolean
}

const DOCUMENTS_HELPER_TEXT =
  'Если у вас есть сертификат ДорХан, прикрепите его, чтобы получать больше заявок'
const COMPANY_NAME_HELPER_TEXT =
  'Укажите название компании, если вы предоставляете услуги от юр. лица или ИП'

export function LkmRegistrationStepTwo({
  onBack,
  onSubmit,
  isSubmitting,
  productTypes,
  productTypesError,
  isUpdateForm,
}: LkmRegistrationStepTwoProps) {
  const { formState, watch, trigger, control } = useFormContext()

  const productTypesValue = watch('productTypes')
  const serviceRegionsValue = watch('serviceRegions')

  useEffect(() => {
    trigger(['productTypes', 'serviceRegions'])
  }, [trigger])

  const isStepTwoValid =
    formState.isValid &&
    productTypesValue.length > 0 &&
    Array.isArray(serviceRegionsValue) &&
    serviceRegionsValue.length > 0

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (onSubmit) onSubmit(e)
  }

  return (
    <form className={styles.secondStepForm} onSubmit={handleSubmit}>
      <div className={styles.secondStepForm__content}>
        <span className='h1'>Дополнительные данные</span>
        <Controller
          name='companyName'
          control={control}
          render={({ field, fieldState }) => {
            const helperText =
              fieldState?.error?.message ?? COMPANY_NAME_HELPER_TEXT

            return (
              <TextField
                inputProps={{
                  autoComplete: 'off',
                }}
                label={'Название компании'}
                error={!!fieldState?.error}
                helperText={helperText}
                {...field}
              />
            )
          }}
        />

        <LkmProductTypes
          productTypes={productTypes}
          error={
            productTypesError ? 'Не удалось загрузить типы изделий' : undefined
          }
        />

        <h4>Адреса работы {!isUpdateForm && '*'}</h4>
        <DadataMultiSelect
          name='serviceRegions'
          inputProps={{
            label: 'Регион обслуживания',
            required: true,
            placeholder: 'Введите адрес для поиска',
          }}
        />
        {!isUpdateForm && (
          <>
            <h4>Сертификаты</h4>

            <DocumentsUploadInput helperText={DOCUMENTS_HELPER_TEXT} />
          </>
        )}
      </div>
      {onBack && onSubmit && (
        <div className={styles.secondStepForm__actions}>
          <Button type='button' variant='outlined' onClick={onBack}>
            Назад
          </Button>
          <Button
            type='submit'
            endIcon={<ChevronRightIcon />}
            variant='contained'
            disabled={!isStepTwoValid || isSubmitting}
          >
            Завершить
          </Button>
        </div>
      )}
    </form>
  )
}
